// frontend/src/components/ui/AnimatedNumber.tsx
// Número que "cuenta" hasta su nuevo valor cuando cambia (no en el primer
// render). Tween propio con requestAnimationFrame: para ~12 contadores no hace
// falta el motor imperativo de Motion. Respeta "reducir movimiento".

import { useEffect, useRef, useState } from 'react';
import { useReducedMotion } from 'motion/react';

const DURACION_MS = 450;
const easeOut = (t: number) => 1 - Math.pow(1 - t, 3);

export function AnimatedNumber({ value }: { value: number }) {
  const [mostrado, setMostrado] = useState(value);
  const desdeRef = useRef(value);
  const reducir = useReducedMotion();

  useEffect(() => {
    const desde = desdeRef.current;
    desdeRef.current = value;
    if (desde === value || reducir) {
      setMostrado(value);
      return;
    }
    let raf = 0;
    const inicio = performance.now();
    const paso = (ahora: number) => {
      const t = Math.min(1, (ahora - inicio) / DURACION_MS);
      setMostrado(Math.round(desde + (value - desde) * easeOut(t)));
      if (t < 1) raf = requestAnimationFrame(paso);
    };
    raf = requestAnimationFrame(paso);
    return () => cancelAnimationFrame(raf);
  }, [value, reducir]);

  return <>{mostrado}</>;
}
